// Collection shortcuts follow the original toolbar without changing its layout.
(() => {
  if (window.rrCollectionHeader) return;
  window.rrCollectionHeader = true;
  let group, label, button, play, source, sourceObserver, drawerObserver, navDrawer, navObserver, frame;
  // History can restore scroll after startup; do not animate that initialization.
  let restoring = true;
  let leaving = false;
  const finishRestore = () => requestAnimationFrame(() => requestAnimationFrame(() => {
    restoring = false;
    update();
    if (group) {
      void group.offsetWidth;
      group.style.removeProperty('transition');
    }
    restoring = false;
  }));
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const update = () => {
    frame = null;
    if (leaving) return;
    const header = document.querySelector('.shopify-section--header');
    const menu = header?.querySelector('button[aria-controls="sidebar-menu"]');
    const title = document.querySelector('.shopify-section--collection-banner .h1');
    const nextSource = document.querySelector('.collection-toolbar .rr-filter-sort-button');
    if (!header || !menu || !title || !nextSource) {
      group?.remove(); group = null; play?.remove(); play = null;
      sourceObserver?.disconnect(); drawerObserver?.disconnect(); navObserver?.disconnect(); navDrawer = null; source = null;
      return;
    }
    if (!group || !group.isConnected) {
      group = document.querySelector('[data-rr-early-collection-header]') || document.createElement('div');
      group.removeAttribute('data-rr-early-collection-header');
      group.classList.add('rr-collection-header');
      if (restoring) group.style.transition = 'none';
      label = group.querySelector('.rr-collection-header__nav') || document.createElement('button'); label.type = 'button'; label.className = 'rr-collection-header__title rr-collection-header__nav';
      label.removeAttribute('aria-controls');
      if (!label.dataset.rrScrollTop) {
        label.dataset.rrScrollTop = 'true';
        label.addEventListener('click', () => window.scrollTo({top:0, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
      }
      button = document.createElement('button'); button.type = 'button';
      button.className = 'rr-collection-header__button';
      button.setAttribute('aria-controls', 'facets-drawer');
      if (!label.isConnected) group.append(label);
      group.append(button);
      if (!group.isConnected) header.append(group);
    }
    if (!play?.isConnected) {
      const originalPlay = document.querySelector('#facets-drawer [data-slideshow-playback]');
      if (originalPlay) {
        play = originalPlay.cloneNode(true);
        play.classList.add('rr-slideshow-resume');
        play.setAttribute('data-slideshow-header-play', '');
        document.body.append(play);
      }
    }
    const showPlay = window.innerWidth >= 1000 && !document.querySelector('#facets-drawer')?.hasAttribute('open') && document.documentElement.dataset.rrSlideshowPaused === 'true';
    if (play) {
      play.hidden = !showPlay;
      play.dataset.playing = 'false';
      play.disabled = !showPlay;
      play.setAttribute('aria-label', play.dataset.playLabel);
    }
    if (source !== nextSource) {
      source = nextSource;
      sourceObserver?.disconnect(); drawerObserver?.disconnect();
      sourceObserver = new MutationObserver(schedule);
      sourceObserver.observe(source, {childList:true, subtree:true, characterData:true});
      const drawer = document.querySelector('#facets-drawer');
      drawerObserver = new MutationObserver(schedule);
      if (drawer) drawerObserver.observe(drawer, {attributes:true, attributeFilter:['open']});
    }
    const nextNavDrawer = document.querySelector('#sidebar-menu');
    if (navDrawer !== nextNavDrawer) {
      navObserver?.disconnect();
      navDrawer = nextNavDrawer;
      navObserver = new MutationObserver(schedule);
      if (navDrawer) navObserver.observe(navDrawer, {attributes:true, attributeFilter:['open']});
    }
    label.textContent = title.textContent.trim(); label.title = label.textContent;
    label.removeAttribute('aria-expanded');
    const sourceBadge = source.querySelector('[data-facets-active-count]');
    const sourceLabel = source.cloneNode(true);
    sourceLabel.querySelector('[data-facets-active-count]')?.remove();
    button.textContent = sourceLabel.textContent.trim().replace(/\s+/g, ' ');
    if (sourceBadge) {
      const badge = document.createElement('span');
      badge.className = 'facets-toolbar-active-count';
      badge.textContent = sourceBadge.textContent;
      button.append(document.createTextNode(' '), badge);
    }
    const filtersOpen = document.querySelector('#facets-drawer')?.hasAttribute('open') || false;
    button.setAttribute('aria-expanded', String(filtersOpen));
    button.classList.toggle('is-drawer-open', filtersOpen);
    button.inert = filtersOpen;
    button.setAttribute('aria-hidden', String(filtersOpen));
    const h = header.getBoundingClientRect(), m = menu.getBoundingClientRect();
    const logo = header.querySelector('.header__logo')?.getBoundingClientRect();
    const available = (logo?.left || h.right) - m.right - 42 - parseFloat(getComputedStyle(header).getPropertyValue('--rr-logo-clearance'));
    // Measure full labels before deciding what fits; never wrap below the header.
    label.style.display = '';
    button.style.display = '';
    const titleWidth = label.getBoundingClientRect().width;
    const buttonWidth = button.getBoundingClientRect().width;
    const gap = Number.parseFloat(getComputedStyle(group).columnGap) || 0;
    const bothFit = titleWidth + gap + buttonWidth <= available;
    const showButton = bothFit || buttonWidth <= available;
    // The faded, inert drawer button must not displace the collection name.
    const showTitle = filtersOpen ? titleWidth <= available : bothFit || (!showButton && titleWidth <= available);
    label.style.display = showTitle ? '' : 'none';
    button.style.display = showButton ? '' : 'none';

    group.style.left = `${m.right - h.left + 42}px`;
    group.style.top = `${m.top - h.top + m.height / 2}px`;
    group.style.maxWidth = `${Math.max(0, available)}px`;
    const visible = window.innerWidth >= 700 && (showTitle || showButton) && source.getBoundingClientRect().bottom <= h.bottom && m.width > 0 && !navDrawer?.hasAttribute('open');
    if (play) play.hidden = !showPlay || !visible;
    const retained = restoring && group.dataset.rrRestoreVisible === 'true';
    group.classList.toggle('is-visible', visible || retained);
    group.inert = !(visible || retained);
    group.setAttribute('aria-hidden', String(!(visible || retained)));
    if (!restoring) delete group.dataset.rrRestoreVisible;
  };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  const rememberReturn = () => {
    try { sessionStorage.setItem('rr-collection-header-return', JSON.stringify({
      url: location.href, visible: !!group?.classList.contains('is-visible'), scrollY: window.scrollY, time: Date.now()
    })); } catch {}
  };
  window.addEventListener('pagehide', () => { rememberReturn(); leaving = true; });
  window.addEventListener('pageshow', () => {
    leaving = false;
    restoring = true;
    if (group) group.style.transition = 'none';
    update();
    finishRestore();
  });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('rr:collection-results-replaced', schedule);
  document.addEventListener('rr:drawer-layout-ready', schedule);
  document.addEventListener('rr:slideshow-playback-state', schedule);
  document.fonts?.ready.then(schedule);
  // Store collection context across tabs; products only use it with a matching referrer.
  let recordedCollectionURL, recordedDrawerOpen;
  const recordCollection = () => {
    const heading = document.querySelector('.shopify-section--collection-banner .h1');
    const drawerOpen = !!document.querySelector('#facets-drawer')?.hasAttribute('open');
    if (!heading || (recordedCollectionURL === location.href && recordedDrawerOpen === drawerOpen)) return;
    try {
      localStorage.setItem('rr-collection-origin:' + location.href, JSON.stringify({
        url: location.href, title: heading.textContent.trim(), drawerOpen, time: Date.now()
      }));
      recordedCollectionURL = location.href; recordedDrawerOpen = drawerOpen;
    } catch {}
  };
  recordCollection();
  window.addEventListener('pageshow', recordCollection);
  document.addEventListener('rr:collection-results-replaced', recordCollection);
  document.addEventListener('pointerdown', recordCollection, true);
  document.addEventListener('contextmenu', recordCollection, true);
  // Remember only explicit collection-to-product navigation in this tab.
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const destination = new URL(link.href, location.href);
    const heading = document.querySelector('.shopify-section--collection-banner .h1');
    if (destination.origin !== location.origin || !destination.pathname.includes('/products/') || !heading) return;
    rememberReturn();
    try {
      sessionStorage.setItem('rr-product-collection-origin', JSON.stringify({
        product: destination.pathname, url: location.href, title: heading.textContent.trim(), drawerOpen: !!document.querySelector('#facets-drawer')?.hasAttribute('open'), time: Date.now()
      }));
    } catch {}
  }, true);
  update();
  if (document.readyState === 'complete') finishRestore();
})();
